import { render, staticRenderFns } from "./save-field-option-dialog.component.vue?vue&type=template&id=6b7be2e4&scoped=true"
import script from "./save-field-option-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./save-field-option-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7be2e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b7be2e4')) {
      api.createRecord('6b7be2e4', component.options)
    } else {
      api.reload('6b7be2e4', component.options)
    }
    module.hot.accept("./save-field-option-dialog.component.vue?vue&type=template&id=6b7be2e4&scoped=true", function () {
      api.rerender('6b7be2e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/save-field-option-dialog/save-field-option-dialog.component.vue"
export default component.exports